import React, { useState, useEffect } from 'react';
import { 
  Briefcase, User, Mail, Phone, MessageSquare, 
  FileText, Download, Eye, Trash2, ChevronDown, 
  ChevronUp, CheckCircle, X, Clock, MapPin
} from 'lucide-react';
import '../css/Applications.css';
import axios from 'axios';


const Applications = () => {
  const [expandedJobId, setExpandedJobId] = useState(null);
  const [expandedAppId, setExpandedAppId] = useState(null);
  const [jobApplications, setJobApplications] = useState([]);

  useEffect(() => {
  const fetchApplicants = async () => {
    try {
      const res = await axios.get('/api/applications');
      const apps = res.data.data;
      console.log('response', res.data);

      const grouped = {};
      apps.forEach((app) => {
        const job = app.career;
        const jobKey = job?.id || "unknown";
        console.log('jobkey', jobKey);

        if (!grouped[jobKey]) {
          grouped[jobKey] = {
            jobTitle: job?.jobTitle || "Unknown Title",
            employmentType: job?.employmentType|| "Unknown Type",
            location: job?.location || "Unknown Location",
            applications: [], 
            totalApplications: 0
          };
        }

        grouped[jobKey].applications.push(app);
        grouped[jobKey].totalApplications += 1;
      });
      console.log('grouped', grouped);
      setJobApplications(grouped);
    } catch (err) {
      console.error("Failed to fetch applications:", err);
    }
  };

  fetchApplicants();
}, []);

  const toggleJob = (jobId) => {
    setExpandedJobId(expandedJobId === jobId ? null : jobId);
    setExpandedAppId(null); // Close any open application when toggling jobs
  };

  const toggleApplication = (appId) => {
    console.log('reached appln toggle', expandedAppId);
    setExpandedAppId(expandedAppId === appId ? null : appId);
    console.log('reached appln toggle', expandedAppId);
  };

  const handleStatusChange = async(appId, newStatus) => {
    console.log('entered status change');
    console.log('newStatus', newStatus);
    console.log('appid', appId);
    try {
       const res = await axios.put(`/api/statusapplications/${appId}/status`,
      { status: newStatus, }
    );
    console.log('response', res);

    setJobApplications(prev => {
  const updated = { ...prev };

  for (const [jobId, group] of Object.entries(prev)) {
    updated[jobId] = {
      ...group,
      applications: group.applications.map(app =>
        app.id === appId ? { ...app, status: newStatus } : app
      ),
    };
  }

  console.log("✅ Updated jobApplications:", updated);
  return updated;
});






    console.log(`Changed application ${appId} status to ${newStatus}`);
    alert(`Application status changed to ${newStatus}!`);
    }
    catch (error) {
    console.error('Status toggle error:', error.response?.data?.message || error.message);
    alert('Failed to update application status');
  }
  };

  const handleDownloadResume = (resumeName) => {
    console.log(`Downloading resume: ${resumeName}`);
    //alert(`Downloading ${resumeName}...`);
      if (!resumeName) return alert("No resume available");
  window.open(resumeName, "_blank");
  };

  const handleDeleteApplication = async(appId) => {
    //try {
    if (window.confirm('Are you sure you want to delete this application?')) {
      const res = await axios.delete(`/api/deleteapplication/${appId}`)
      console.log(`Deleted application: ${appId}`, res);
      setJobApplications((prev) => {
        const updated = {};
        for (const [jobId, group] of Object.entries(prev)) {
          const filteredapp = group.applications.filter(app => app.id!== appId);
          updated[jobId] = {
            ...group,
            applications: filteredapp,
          };
        }
         console.log("Updated after deletion:", updated);
        return updated;
      });
      alert('Application deleted successfully!');
    }
  //}
  };

  return (
    <div className="applications-container">
      {/* Header */}
      <div className="applications-header">
        <div className="header-info">
          <h1>Job Applications</h1>
          <p>Review and manage all candidate applications</p>
        </div>
        <div className="header-stats">
          <div className="stat-card-small">
            <span className="stat-number">5</span>
            <span className="stat-label">Total Applications</span>
          </div>
          <div className="stat-card-small">
            <span className="stat-number">2</span>
            <span className="stat-label">Open Positions</span>
          </div>
        </div>
      </div>

      {/* Jobs with Applications */}
      <div className="jobs-applications-list">
        {/* {jobApplications.map((job) => ( */}
        {Object.entries(jobApplications).map(([jobId, group]) => (
          //  if (!group || typeof group !== 'object') return null;

          <div key={jobId} className={`job-section ${expandedJobId === jobId ? 'expanded' : ''}`}>
            {/* Job Header */}
            <div className="job-section-header" onClick={() => toggleJob(jobId)}>
              <div className="job-header-left">
                <div className="job-header-icon">
                  <Briefcase size={24} />
                </div>
                <div className="job-header-info">
                  <h2>{group.jobTitle}</h2>
                  <div className="job-header-meta">
                    <span className="meta-item">
                      <MapPin size={14} />
                      {group.employmentType}
                    </span>
                    <span className="meta-item">
                      <MapPin size={14} />
                      {group.location}
                    </span>
                  </div>
                </div>
              </div>
              <div className="job-header-right">
                <div className="applications-count">
                  <User size={18} />
                  <span>{group.totalApplications} {group.totalApplications === 1 ? 'Application' : 'Applications'}</span>
                </div>
                <button className="expand-btn">
                  {expandedJobId === jobId ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </button>
              </div>
            </div>

            {/* Applications List */}
            {expandedJobId === jobId && (
              <div className="applications-list">
                {group.applications.map((app) => (
                  <div key={app.id} className={`application-card ${expandedAppId === app.id ? 'expanded' : ''}`}>
                    {/* Application Card Header */}
                    <div className="application-card-header" onClick={() => toggleApplication(app.id)}>
                      <div className="app-header-left">
                        <div className="applicant-avatar">
                          {(app.fullName || "U").split(" ").map(n => n[0]).join("")}
                        </div>
                        <div className="applicant-info">
                          <h3>{app.fullName || "Unknown Applicant"}</h3>
                          <div className="applicant-meta">
                            <span className="meta-tag">
                              <Mail size={12} />
                              {app.email}
                            </span>
                            <span className="meta-tag">
                              <Clock size={12} />
                              Applied on {new Date(app.appliedDate).toLocaleDateString()}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="app-header-right">
                        <span className={`status-badge ${app.status.toLowerCase().replace(' ', '-')}`}>
                          {app.status}
                        </span>
                        <button className="expand-toggle" onClick={(e) => { e.stopPropagation(); toggleApplication(app.id); }}>
                          {expandedAppId === app.id ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                        </button>
                      </div>
                    </div>

                    {/* Application Details */}
                    {expandedAppId === app.id && (
                      <div className="application-details">
                        {/* Action Buttons */}
                        <div className="app-actions">
                          <button 
                            className="app-action-btn download"
                            onClick={() => handleDownloadResume(app.resume_url)}
                          >
                            <Download size={16} />
                            Download Resume
                          </button>
                          <button 
                            className="app-action-btn delete"
                            onClick={() => handleDeleteApplication(app.id)}
                          >
                            <Trash2 size={16} />
                            Delete
                          </button>
                        </div>

                        {/* Application Info Grid */}
                        <div className="app-details-grid">
                          <div className="app-detail-item">
                            <div className="detail-label">
                              <User size={16} />
                              Full Name
                            </div>
                            <div className="detail-value">{app.fullName}</div>
                          </div>

                          <div className="app-detail-item">
                            <div className="detail-label">
                              <Mail size={16} />
                              Email Address
                            </div>
                            <div className="detail-value">
                              <a href={`mailto:${app.email}`} className="contact-link">{app.email}</a>
                            </div>
                          </div>

                          <div className="app-detail-item">
                            <div className="detail-label">
                              <Phone size={16} />
                              Phone Number
                            </div>
                            <div className="detail-value">
                              <a href={`tel:${app.phone}`} className="contact-link">{app.phone}</a>
                            </div>
                          </div>

                          {/* <div className="app-detail-item">
                            <div className="detail-label">
                              <Briefcase size={16} />
                              Applied Position
                            </div>
                            <div className="detail-value position-value">{app.position}</div>
                          </div> */}

                          <div className="app-detail-item">
                            <div className="detail-label">
                              <FileText size={16} />
                              Resume
                            </div>
                            <div className="detail-value">
                              <button 
                                className="resume-link"
                                onClick={() => handleDownloadResume(app.resume_url)}
                              >
                                <FileText size={14} />
                                {app.resume_docname}
                              </button>
                            </div>
                          </div>

                          <div className="app-detail-item">
                            <div className="detail-label">
                              <Clock size={16} />
                              Application Date
                            </div>
                            <div className="detail-value">
                              {new Date(app.appliedDate).toLocaleDateString('en-US', { 
                                weekday: 'long', 
                                year: 'numeric', 
                                month: 'long', 
                                day: 'numeric' 
                              })}
                            </div>
                          </div>
                        </div>

                        {/* Message Section */}
                        <div className="app-message-section">
                          <div className="detail-label">
                            <MessageSquare size={16} />
                            Cover Letter / Message
                          </div>
                          <div className="message-content">
                            {app.message}
                          </div>
                        </div>

                        {/* Status Actions */}
                        <div className="status-actions-section">
                          <h4>Update Application Status</h4>
                          <div className="status-actions-grid">
                            <button 
                              className="status-action-btn shortlisted"
                              onClick={() => handleStatusChange(app.id, 'ShortListed')}
                            >
                              <CheckCircle size={18} />
                              Shortlist
                            </button>
                            <button 
                              className="status-action-btn review"
                              onClick={() => handleStatusChange(app.id, 'Under Review')}
                            >
                              <Eye size={18} />
                              Review
                            </button>
                            <button 
                              className="status-action-btn rejected"
                              onClick={() => handleStatusChange(app.id, 'Rejected')}
                            >
                              <X size={18} />
                              Reject
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Applications;